import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ERROR_HANDLERS, ErrorResponseHandler } from './error-response-handler';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  private handlers: ErrorResponseHandler[];

  constructor(@Inject(ERROR_HANDLERS) private errorHandlers: readonly ErrorResponseHandler[]) {
    this.handlers = [...errorHandlers].sort((a, b) => b.priority - a.priority);
  }

  buildErrorMessages(error: HttpErrorResponse): string[] {
    for (const handler of this.errorHandlers) {
      if (handler.canHandle(error)) {
        const messages: string[] = this.handleError(handler, error);
        if (messages.length > 0) {
          return messages;
        }
      }
    }

    return ['An unknown error occurred.'];
  }

  private handleError(handler: ErrorResponseHandler, error: HttpErrorResponse): string[] {
    const handlerMessages: string[] = handler.buildErrorMessages(error);

    const nonEmptyMessages: string[] = [];
    for (const message of handlerMessages) {
      if (message && message.trim().length > 0) {
        nonEmptyMessages.push(message);
      }
    }

    return nonEmptyMessages;
  }
}
